import portadalibro from "../assets/img/portadalibro.webp";

const EbookData = [
    {
        // --- Datos Generales del Ebook ---
        id: 'ebook-programacion-01', // El ID que usarás en la URL, ej: /ebook/ebook-programacion-01
        idCourse: "1",
        active: true,
        title: "Ebook: Programación para Todos;",
        brandName: "Dissemp Academy",
        footerText: "Construye el futuro que quieres. El primer paso es hoy.",
        coverImage: portadalibro,
        coverImageAlt: "Portada del Ebook Programación para Todos;",

        // --- Contenido de la Landing Page ---
        titleMain: [
            { text: "Aprende lógica de programación desde cero y", style: { color: "#ffffff", fontWeight: "bold" } },
            { text: " escribe tu primera línea en menos de 7 días.", style: { color: "#00cfff", fontWeight: "bold" } },
            { text: "Aunque nunca hayas programado antes.", style: { color: "#ffffff", fontWeight: "bold" } }
        ],
        hook: [
            { text: 'Nuestro ebook ', style: { color: '#b0b0b0', fontWeight: 'normal' } },
            { text: '"Programación para Todos;"', style: { color: '#b0b0b0', fontWeight: 'normal', fontStyle: 'italic' } },
            { text: ' es la guía ', style: { color: '#b0b0b0', fontWeight: 'normal' } },
            { text: 'directa y sin rodeos', style: { color: '#ffffff', fontWeight: 'bold' } },
            { text: ' que necesitas para entender la lógica detrás del código y empezar a crear, incluso si crees que no eres ', style: { color: '#b0b0b0', fontWeight: 'normal' } },
            { text: '"bueno"', style: { color: '#b0b0b0', fontWeight: 'normal', fontStyle: 'italic' } },
            { text: ' para esto.', style: { color: '#b0b0b0', fontWeight: 'normal' } }
        ],
        hookMain: "✅ Más de 329 alumnos ya aprendieron programación con este eBook. ¿Listo para ser el siguiente?",
        mainButtonText: "¡QUIERO MI EBOOK AHORA!",
        subButtonText: "Acceso inmediato y garantía de calidad.",
        problems: {
            title: "¿Te suena familiar?",
            subtitle: "Intentas aprender a programar, pero terminas en un ciclo de frustración.",
            items: [
                { icon: 'infinity', title: 'Sobrecarga de Información', description: 'Miles de tutoriales, videos y cursos. No sabes por dónde empezar y saltas de uno a otro sin avanzar.' },
                { icon: 'puzzle', title: 'Conceptos que no "Conectan"', description: 'Aprende teoría (variables, funciones) pero no logra aplicarla a la vida real, todo se siente abstracto.' },
                { icon: 'frown', title: 'El Muro de la Frustración', description: 'Tu primer error te detiene. El código no funciona, no sabes por qué, y terminas abandonando y sintiéndote incapaz.' }
            ]
        },
        solution: {
            title: [
                { text: "La", style: { fontWeight: "bold", fontSize: "2.2rem", color: "#ffffff" } },
                { text: " solución", style: { fontWeight: "bold", fontSize: "2.2rem", color: "#00CFFF" } },
                { text: " es un mapa, no más tutoriales sueltos.", style: { fontWeight: "bold", fontSize: "2.2rem", color: "#ffffff" } }
            ],
            description: [
                { text: "Hemos condensado años de enseñanza en una guía fácil de leer. Este ebook no te enseñará 10 lenguajes de programación. Te enseñará algo mucho más valioso: ", style: { fontWeight: "normal", fontSize: "1rem", color: "#B0B8C2", marginTop: "1rem" } },
                { text: "La lógica universal que hay detrás de TODOS ellos.", style: { fontWeight: "bold", fontSize: "1rem", color: "#ffffff" } }
            ],
            points: [
                [
                    { text: "Claridad desde la primera página.", style: { fontWeight: "bold", color: "#ffffff" } },
                    { text: " Cero jerga técnica innecesaria. Te hablo como a un amigo que está aprendiendo.", style: { fontWeight: "normal", color: "#B0B8C2" } }
                ],
                [
                    { text: "Ejemplos prácticos y analogías.", style: { fontWeight: "bold", color: "#ffffff" } },
                    { text: " Entenderás qué es una variable con el ejemplo de una caja, y qué es una función con una receta de cocina.", style: { fontWeight: "normal", color: "#B0B8C2" } }
                ],
                [
                    { text: "Enfocado en la confianza.", style: { fontWeight: "bold", color: "#ffffff" } },
                    { text: " Cada capítulo está diseñado para darte una pequeña victoria, motivándote a seguir adelante.", style: { fontWeight: "normal", color: "#B0B8C2" } }
                ]
            ]
        },

        features: {
            title: "Dentro del Ebook Descubrirás:",
            items: [
                { icon: 'brain-circuit', title: 'Pensamiento Lógico', description: 'Cómo desarrollar la habilidad clave para pensar como programador y resolver problemas paso a paso.', delay: 0 },
                { icon: 'repeat', title: 'Algoritmos y Pseudocódigo', description: 'Aprenderás a planear antes de programar y representar tus ideas con lógica clara.', delay: 100 },
                { icon: 'box', title: 'Variables y Tipos de Datos', description: 'Qué es una variable, cómo funciona y cómo representan información en tu código.', delay: 150 },
                { icon: 'git-compare', title: 'Estructuras de Control', description: 'Condicionales y ciclos para que tu programa pueda tomar decisiones y repetir tareas.', delay: 200 },
                { icon: 'map', title: 'Arreglos', description: 'Cómo agrupar datos similares en una sola estructura y acceder a ellos eficientemente.', delay: 250 },
                { icon: 'blender', title: 'Funciones', description: 'Cómo escribir bloques de código reutilizables y mantener tu programa organizado.', delay: 300 },
                { icon: 'puzzle', title: 'Programación Orientada a Objetos', description: 'Entiende cómo modelar objetos del mundo real con clases y métodos.', delay: 350 },
                { icon: 'infinity', title: 'Lenguajes y Frameworks del Momento', description: 'Conoce las tecnologías más usadas hoy: JavaScript, Python, React, Node.js y más.', delay: 400 }
            ]
        },
        cta: {
            title: "Consigue tu copia por menos de lo que cuestan un par de cafés.",
            subtitle: "Invierte en una base sólida que te ahorrará incontables horas de frustración y te pondrá en el camino correcto desde el día uno.",
            buttonText: "SÍ, ¡QUIERO OBTENERLO YA!",
            guarantee: {
                title: "Garantía de Calidad",
                description: "Garantía de 5 días: si no aprendes lo básico de programación en la primera semana, te devolvemos el 80% de tu dinero"
            }
        },
        faq: {
            title: "Tus Dudas, Resueltas",
            items: [
                { id: 1, question: '¿Necesito algún programa o software especial?', answer: 'No. Para los ejemplos del ebook, te mostraré cómo usar herramientas online y gratuitas. No necesitas instalar nada complicado para empezar.' },
                { id: 2, question: '¿Este ebook es sobre Python, JavaScript u otro lenguaje?', answer: 'Este ebook se enfoca en los fundamentos universales de la programación con ejemplos en Javascript. La lógica que aprendas aquí te servirá para CUALQUIER lenguaje que decidas aprender después. De hecho, te ayudará a aprenderlos mucho más rápido.' },
                { id: 3, question: 'Soy muy malo/a para las matemáticas, ¿puedo programar?', answer: '¡Claro que sí! Es uno de los grandes mitos. Para la gran mayoría de las áreas de la programación (como desarrollo web o de apps), solo necesitas saber sumar, restar, multiplicar y dividir. La habilidad más importante es la lógica, y eso es justo lo que te enseñará este ebook.' },
                { id: 4, question: '¿Cómo recibo el ebook después de pagar?', answer: 'Inmediatamente. Después de completar el pago seguro, recibirás un correo electrónico con un enlace para descargar tu ebook en formato PDF, compatible con cualquier computadora, tablet o smartphone.' }
            ]
        },
        // --- Datos para la lógica de la App ---
        values: {
            us: { newPrice: 10, oldPrice: 18, currency: '$' },
            co: { newPrice: 39900, oldPrice: 65000, currency: 'COP' },
            ve: { newPrice: 2300, oldPrice: 3500, currency: 'Bs' },
            cl: { newPrice: 9490, oldPrice: 13500, currency: 'CLP' },
            mx: { newPrice: 179, oldPrice: 200, currency: 'MXN' },
            pe: { newPrice: 39, oldPrice: 65, currency: 'PEN' },
        }
    }
];

export default EbookData;
